import { Steps, Step } from 'components/Docs/Steps';
import { CalloutBox } from 'components/Docs/CalloutBox';
import InstallReactNative from "../../../../contents/docs/integrate/_snippets/install-react-native.mdx";
import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import StepUploadSymbolSets from "../../../../contents/docs/error-tracking/installation/_snippets/step-upload-symbol-sets.tsx";
import * as React from 'react';
export default {
  Steps,
  Step,
  CalloutBox,
  InstallReactNative,
  StepVerifyErrorTracking,
  StepUploadSymbolSets,
  React
};